var SOLD = 'Sold';
var decks = {}, categories = {}, paperCache = {}, allCabins = {}, cabinCache = {};
var curDrawIntervalID;
var validCabinRE = /([A-Z]|[1-9])(\d){4}/;
var deckProgressBar;

var cabinFound, cabinFoundText;

var ship = {
	code: null,
	xml : '',
	getDecks : function(shipCode){
		var options, selected = '';
		 
		ship.xml.find('Deck').each(function(){
			var number = $(this).attr('number');
			var name = $(this).attr('name');
			if( (number == 7 && !(shipCode == 'PA' || shipCode == 'OP')) || (number == 9 && (shipCode == 'PA' || shipCode == 'OP'))){
				selected = 'selected="selected"';
			}
			
			options += '<option value="'+number+'"'+selected+'>Deck '+number+' &ndash; '+name+'</option>';
			selected = '';
		});
		return options;
	},	
	getPublicAreas : function(deckNo){
		var publicAreasList = '';
		ship.xml.find('Deck').each(function(){
			var curDeckNo = $(this).attr('number');
			if( deckNo == parseInt(curDeckNo) ){
				publicAreasList = '<ul id="public-areas-list">';
				$(this).find('PublicRoom').each(function(){
					var name = $(this).attr('name');
					var vrx = $(this).attr('vrx');
					var vrxLink = '';
					
					/* Feature removed
					if( vrx != ''){
						vrxLink ='<a href="'+vrx+'">'+name+'</a>';
					}
					*/
					publicAreasList += '<li>' + (vrxLink == '' ? name : vrxLink )+'</li>'; 
				});
				publicAreasList +='</ul>';
				return;
			}
		});
		return publicAreasList;
	}
		
};

var filter = {
	noOfPax : '',
	metas : [],
	connectingCabin : false,
	wheelchair : false,
	deck: 7,
	version: 5,
	
	occupancy : function(noOfBerths){
		switch( this.noOfPax ){
			case '3':
				return (noOfBerths == 3 || noOfBerths == 4);
			case '4':
				return (noOfBerths == 4);
			default:
				return true;
		}
		return true;
	},
	
	meta : function(cabinMetaCode){
		if(this.metas.length > 0){
			for( var i = 0; i < this.metas.length; i++ ){
				if( cabinMetaCode == this.metas[i]){
					return true;
				}
			}
			return false;

		}
		//show all metas if nothing is passed
		return true;
	},
	
	connectingRoom: function( connectingRoom ){
		if(this.connectingCabin){			
			return connectingRoom && connectingRoom.length > 0;
		}
		return true;
	},
	
	ada: function( accessible ){
		if(this.wheelchair){	
			return accessible;
		}
		return true;
	},
	
	result : function( cabin ){		
		return this.meta(cabin.data('metaCode')) && this.occupancy(cabin.data('noOfBerths')) && this.ada(cabin.data('wheelchairAccessible')) && this.connectingRoom(cabin.data('connectingRoom'));
	}
};



function initDeckPlans(){  

	var deckholder = $('#deck-holder');
	var deckNo = filter.deck;
	var widgetTopPos = $("#widget").offset().top;
	deckProgressBar = $( '#progressbar' ).progressbar();	
	$('#meta-options input').filter(':checked').each(function(){
		$(this).prop('checked',false);
	});

	paperCache[deckNo] = deckPlans.getPaper(deckNo);
	
	var shipCode = ship.code.toLowerCase();
	
	$.get('/static/learn/ships/'+shipCode+'/deck_plans/v'+filter.version+'/'+shipCode+'_deck.xml?r='+(new Date()).getTime()).done(function(data){
		ship.xml = $(data);
		$('#deck-no').append(ship.getDecks(ship.code));
		$('#no-available-public-areas').hide();
		$('#public-areas').append(ship.getPublicAreas(filter.deck));
	});

	$('a[href="#top"]').on('click',function(e){
		e.preventDefault();
		$('html, body').animate({scrollTop:0}, 'slow', 'swing');
	});	
	
	$('#change-date-button').on('click', function(e){
		e.preventDefault();	
		deckPlans.removeQtips();
		$('html, body').animate({ scrollTop: 0}, 0, function(){	
			deckholder.animate({
				right: 0
			});
			$('#deckplan').animate({
				opacity: 0
			});
			$('#deck-plan-landing').animate({
				opacity: 100
			});
		});
	});

	
	$('#ship-overlay').css('height',$('#ship').height());
	
	$('#btnStaterooms').on('click', function(){
		$('#public-areas').slideUp('fast');
		$('#state-rooms').slideDown('fast');
		$('#btnPublicAreas').removeClass('selected');
		$('#btnStaterooms').addClass('selected');
	});

	$('#btnPublicAreas').on('click',function(){
		$('#state-rooms').slideUp('fast');
		$('#public-areas').slideDown('fast');
		$('#btnPublicAreas').addClass('selected');
		$('#btnStaterooms').removeClass('selected');
	});
	
	var scrollTop;
	var widgetBottom;
	var headerHeight = $('#princess-header').outerHeight(true);
	var widgetHeight = $('#widget').outerHeight(true);
	var shipNameHeight = $('#ship-name').outerHeight(true);
	var disclaimerHeight = $('#disclaimer').outerHeight(true);
	var footerHeight = $('#princess-footer').outerHeight(true);
	var contentHeight;
	var bottomCatch;
	var da;

	var topCatch = headerHeight + shipNameHeight + 15;

	var tabContent = $('#tab-content');

	if(tabContent.length > 0){
		da = true;
		var priceDisclaimerHeight = $('.disclaimer').outerHeight(true);
		var itineraryDetailsHeight = $('.cruise-details').outerHeight(true);
		var tabsHeight = $('#tabs').outerHeight(true);
		var saleDisclaimerHeight = $('.sale-disclaimer').outerHeight(true);
		var topCatch = headerHeight + itineraryDetailsHeight + tabsHeight + 30;
		var widgetTop = topCatch;
	}else{
		da = false;
	}

	shipHeight = $('#ship').height();
	
	$(window).on('scroll', function(){
		scrollTop = $(window).scrollTop();
		widgetHeight = $('#widget').outerHeight(true);
		widgetBottom = scrollTop + widgetHeight;
		tabHeight = $('.tab-section').outerHeight(true);
		contentHeight = $('#content').outerHeight(true);
		bottomCatch = headerHeight + contentHeight - disclaimerHeight;

		if(da == true){
			bottomCatch = bottomCatch + tabHeight - footerHeight - priceDisclaimerHeight - saleDisclaimerHeight;
		}
		if((scrollTop >= widgetTopPos) && (widgetBottom < bottomCatch)){
			$('#widget').addClass('fixed');
			$('#widget').removeClass('bottom');
		}
		if(scrollTop < widgetTopPos){
			$('#widget').removeClass('fixed');
		}
		
		if(widgetBottom > bottomCatch){
			$('#widget').removeClass('fixed');
			$('#widget').addClass('bottom');
		}
	});
	
	$('#sr-number').on('keypress', function(e) {
	    if (e.which == 13) {
	        e.preventDefault();
	        $('#sr-number-find').trigger('click');
	    }
	});
	
	
	$('#sr-number-find').on('click', function(e){
		e.preventDefault();
		var deckNumEx = new RegExp("^[a-zA-Z0-9]+$");
		//deckPlans.removeQtips();
		var number = DOMPurify.sanitize($('#sr-number').val()).toUpperCase();
		$('#sr-number').val(number);
		if (!deckNumEx.test(number)){
			deckPlans.mfpLightbox( 'inline', '#filter-no-staterooms', 'No matching staterooms', 640 );
			return;
		}
		var cabin = $('#cabin-'+number);
		if( cabin.length > 0 && cabin.prop('id').match(validCabinRE) && cabin.closest('div').is(':visible')){
			clearInterval(intervalId);
			deckPlans.colorFill(filter.deck);
			$('html, body').animate({ scrollTop: cabin.offset().top - 375}, 1000, function(){
				cabin.trigger('mouseover');
				deckPlans.highlight(deckPlans.getCabinNo(cabin.prop('id')));
				
			});
		}
		else{
			prevDeck = filter.deck;
			
			$.when( deckPlans.getCabin(ship.code, filter.version, number)
					.done(function(cabin){
						if(cabin){
							deckPlans.getCategories(ship.code, filter.version, cabin.deckNumber);
						}
					}))
					.done(function(cabin){
						if(!cabin){
							deckPlans.mfpLightbox( 'inline', '#filter-no-staterooms', 'No matching staterooms', 640 );
							return;
						}
						if( $('#deck-'+cabin.deckNumber).length == 0 ){
							$('#deck-'+prevDeck).hide();
							$('#ship').append('<div id="deck-'+cabin.deckNumber+'"/>');
						}
						else{
							$('#deck-'+prevDeck).hide();
						}
						filter.deck = cabin.deckNumber;
						
						$.when(deckPlans.getDeck(ship.code, filter.version, cabin.deckNumber)).done(function(){
							intervalId = setInterval(function(){
								var searchCabinNo = DOMPurify.sanitize($('#sr-number').val());
								cabin = $('#cabin-' + searchCabinNo);
								if(cabin.length > 0){
									clearInterval(intervalId);
									deckPlans.colorFill(filter.deck);
									$('html, body').animate({ scrollTop: cabin.offset().top - 375}, 1000, function(){
										var mouseoverId = setInterval(function(){
											if(deckProgressBar.hasClass('invisible')){
												cabin.trigger('mouseover');	
												deckPlans.highlight(deckPlans.getCabinNo(cabin.prop('id')));
												clearInterval(mouseoverId);
											}
										}, 100);
									});
								}
							},15);
						});						
						$('#deck-profile').removeClass('deck-'+prevDeck).addClass('deck-'+cabin.deckNumber);
						$('#deck-no option').each(function(){
							if( $(this).val() ==  cabin.deckNumber ){
								$(this).prop('selected', true);
							}
						});
					})
					.fail(function(req,error){
						if(error === 'error'){error = req.statusText;}
							deckPlans.mfpLightbox( 'inline', '#stateroom-not-found', 'Your stateroom could not be found', 640 );
					});
			}
	});
	 
	$('#widget').on('click', '#meta-category input[type=checkbox]', function() {		
		filter.metas = $('#meta-category input:checkbox:checked').map(function() {
			return this.value;
		}).get();
		if( !deckPlans.colorFill(filter.deck) ){
			$(this).prop('checked',false);
		}
	});

	$('#state-rooms').on('click', function() {
        if ($(this).hasClass('disable-stateroom')) {
            return false; // Prevent click event when div is disabled
        }
    });
	
	$('#deck-no').on('change', function() {
		$(this).prop('disabled', true);
		$('#state-rooms').addClass('disable-stateroom');
		if( curDrawIntervalID != null ){
			clearInterval(curDrawIntervalID);
		}
		var curDeck = filter.deck;
		
		$('#deck-'+curDeck).hide();
		
		filter.deck = DOMPurify.sanitize($('option:selected', this).val());
		$('#deck-profile').removeClass('deck-'+curDeck).addClass('deck-'+filter.deck);	
		
		var publicAreas = $(ship.getPublicAreas(filter.deck));
		if( publicAreas.find('li').length > 0 ){
			$('#no-available-public-areas').hide();
			$('#public-areas-list').remove();
			$('#public-areas').append(publicAreas);
		}
		else{
			var paList = $('#public-areas-list');
			if( paList.length > 0 ){
				paList.remove();
			}
			$('#no-available-public-areas').show();
		}
		
		var deckId = 'deck-'+filter.deck;
		if( $('#'+deckId).length == 0 ){
			$('#ship').append('<div id="'+deckId+'"/>');
		}
		else{
			$('#'+deckId).show();
			var key = filter.deck+'-'+filter.version;
			if( decks[filter.deck] && decks[filter.deck].complete){
				deckProgressBar.addClass('invisible');
				$('#ship-overlay').hide();
			}
			
		}
		$.when(deckPlans.getCategories(ship.code, filter.version, filter.deck)).done(function(){
			$('#meta-category input').each(function(){
				$(this).prop('checked',( $.inArray($(this).val(),filter.metas) > -1 ) );
	
			});			
			filter.metas = $('#meta-category input:checkbox:checked').map(function() {
				return this.value;
			}).get();			
			$('#number-passengers option').each(function(){
				if($(this).val() == filter.noOfPax){
					$(this).prop('selected', true);
					return;
				}
			});
			$('#wheelchair-accessible').prop('checked', filter.wheelchair);
			$('#connection-cabins').prop('checked', filter.connectingCabin);
			
			$.when(deckPlans.getDeck(ship.code, filter.version, filter.deck)).done(function(){
				
				/*
				console.log($('#'+deckId));
				$('#'+deckId).find('[id*="cabin"]').length > 0 ? $('#btnStaterooms').trigger('click') : $('#btnPublicAreas').trigger('click');
				console.log($('#'+deckId).find('[id*="cabin"]').length);
				*/
				
				
			});			
		});
		
		//fix what's above and what's below
		//What's Below
		var decksSelect = $('option', this);
		var index = $(this).prop('selectedIndex');	
		(decksSelect.length - 1 >  index + 1 ) ? $('#whats-below').removeClass('gray').addClass('blue') : $('#whats-below').removeClass('blue').addClass('gray');

		//What's Above
		(index - 1 >= 0 ) ? $('#whats-above').removeClass('gray').addClass('blue') : $('#whats-above').removeClass('blue').addClass('gray');
		
	});
	
	$('#widget').on('change', '#number-passengers', function() {	
		filter.noOfPax = $('option:selected', this).val();
		if( !deckPlans.colorFill(filter.deck) ){
			$('option', this).eq(0).prop('selected',true);
			filter.noOfPax = 2;
			deckPlans.colorFill(filter.deck);
		}
		
	});
	
	
	$('#widget').on('click', '#wheelchair-accessible', function() {
		filter.wheelchair = $(this).is(':checked');
		if( !deckPlans.colorFill(filter.deck) ){
			$(this).prop('checked',false);
			filter.wheelchair = false;
			deckPlans.colorFill(filter.deck);
			
		}
	});
	
	$('#widget').on('click', '#connection-cabins', function() {
		filter.connectingCabin = $(this).is(':checked');
		if( !deckPlans.colorFill(filter.deck) ){
			$(this).prop('checked',false);
			filter.connectingCabin = false;
			deckPlans.colorFill(filter.deck);
		}
	});

	//Do some real work.
	var stateroom = $.getUrlVar('stateroom') ? $.getUrlVar('stateroom').match(validCabinRE) || [] : [];
	if(stateroom.length > 0 ){
		$('#sr-number').val(stateroom[0]);
		$('#sr-number-find').trigger('click');
	}
	else{
		$('#deck-no').prop('disabled',true);
		$('#state-rooms').addClass('disable-stateroom');
		deckPlans.getDeck(ship.code, filter.version, filter.deck);
	}
	
}


var deckPlans = {
	highlight : function( id ){
		var hitArea = allCabins[id].hitArea;
		cabinFound = hitArea.prev.prev;
		cabinFoundText = hitArea.prev;
		
		
		cabinFound.animate({
			 fill: deckStyle.hover.fill
		 }, 0);
		cabinFoundText.animate({
			 fill: deckStyle.hoverText.fill
		 }, 0);
	},
	
	getDeck : function(shipCode, version, deck, forceRedraw){
		var key = deck+'-'+version;
		if(!decks[key] || !decks[key].complete || forceRedraw ){
			$('#percent').text('...');
			deckProgressBar.progressbar('value', 0);
			deckProgressBar.removeClass('invisible');
			$('#ship-overlay').show();

			return $.ajax({
				type: 'GET',
				cache: false,
				data: { shipCode: shipCode, version: version, deck: deck},
				url: '/getDeckJSON.do?',
				dataType: 'json'
			})
			.done(function( data ){			
					decks[key] = {
						data: data,
						complete: false
					};
					deckPlans.drawDeck(decks[key].data, shipCode, deck, version); 
			})
			.fail(function(req,error){
				if(error === 'error'){error = req.statusText;}
					deckPlans.mfpLightbox( 'inline', '#server-error-msg', 'Deck Plan Unavailable', 640 );
					$("#progress-text").text('Sorry, deck plans are currently unavailable.').addClass('red');
			});
		}
		else{
			$('#deck-no').prop('disabled',false);
			$('#state-rooms').removeClass('disable-stateroom');
			$('#deck-'+deck).show().find('[id*="cabin"]').length > 0 ? $('#btnStaterooms').trigger('click') : $('#btnPublicAreas').trigger('click');
			if( !deckPlans.colorFill(deck) ){								
				deckPlans.colorFill(deck);
			}
		}
		
	},
	getCategories : function(shipCode, version, deck){
		var key = deck+'-'+version;
		if(!categories[key]){
			return cat = $.ajax({
				type: 'GET',
				cache: false,
				data: { shipCode: shipCode, version: version, deck: deck},
				url: '/getCategories.do?',
				dataType: 'html'
			})
			.done(function( data ){	
				var html = $(data);
				html.find('tr:last td').removeClass('medium-border-bottom');
				$('#state-rooms').empty().append(html);
				categories[key] = html;

			})
			.fail(function(req,error){
				if(error === 'error'){error = req.statusText;}
					deckPlans.mfpLightbox( 'inline', '#server-error-msg', 'Deck Plan Unavailable', 640 );
			});
		}
		else{
			$('#state-rooms').empty().append(categories[key]);
		}
	},
	
	getCabin : function(shipCode, version, number){
		var promise = cabinCache[ number ];
		var cabin = this.getFetchedCabin(number);
		if( cabin ){
			var dff = $.Deferred();
			dff.resolve(allCabins[number]);
			promise = dff.promise(); 
			return promise;
		}
		else{
			promise = $.ajax({
				type: 'GET',
				cache: false,
				data: { shipCode: shipCode, version: version, number: number},
				url: '/getCabin.do?',
				dataType: 'json'
			});

			cabinCache[ number ] = promise;
			
		}
		return promise;
	},
	
	getFetchedCabin : function(number){
		for(var cabinNo in allCabins) {
			if( cabinNo == number ){
				return true;
			}
		}
		return null;
	},
	
	drawDeck : function(deck, shipCode, deckNo, version){
		var start = (new Date()).getTime(),
			paper = paperCache[deckNo] || (paperCache[deckNo] = deckPlans.getPaper(deckNo)),
			$container = $('#deck-'+deckNo),
			clean_deck_no = DOMPurify.sanitize( deckNo ),
			svg_title = 'Deck ' + clean_deck_no + ' Diagram',
			deck_name = DOMPurify.sanitize($("#deck-no option:selected").text()) || ('Deck ' + clean_deck_no),
			svg_description = 'Map of major features on ' + deck_name + '. Please refer to the Accessible Routes link for more deck information.',
			$title = $('<title id="svg-title-'+ clean_deck_no +'">' + svg_title + '</title>'),
			imgSrc = '/static/images/global/decks/'+shipCode+'_'+deckNo+'_bg_'+version+'.png',
			$svg = $container.find('svg');
		
		$('<img />').attr('src', imgSrc).on("load", function(){
		
			paper.setSize($(paper.canvas).width(), this.height);
			paper.image( imgSrc, 0, 0, this.width, this.height);
			$('#deck-'+deckNo+' image').attr('role', 'presentation');
			$('#ship').css({'min-height': this.height});
			$('#ship-overlay').height(this.height);
			
			contentHeight = $('#content').outerHeight(true);
			
			var i = 0, limit = deck.cabins.length;
			var percent = $('#percent');
			var key = deckNo+'-'+version;
			
			if( deck.cabins.length > 0 ){
				curDrawIntervalID = setInterval(function(){
				    	deckPlans.draw(i, deck, paper);
				    	var complete = parseInt((i /deck.cabins.length)*100);
				    	percent.text(complete+'%');
				    	deckProgressBar.progressbar("value", complete);
				    	
				    	if( ++i == limit ){

				    		clearInterval(curDrawIntervalID);
    			    		var g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
				    		g.setAttribute('role','list');
				    		g.setAttribute('aria-label', 'Deck ' + clean_deck_no + ' List of Cabins');
				    		$groups = $svg.find('g')
				    		$groups.wrapAll(g);
				    		var end = (new Date()).getTime();
				    		var dur = (end-start)/1000;
				    		deckProgressBar.progressbar("value", 100);				    	
							if( !deckPlans.colorFill(deckNo) ){								
								deckPlans.colorFill(deckNo);
							}
				    		deckPlans.attachQtip();

	    					deckPlans.attachCabinClickHandlers();
				    		deckProgressBar.addClass('invisible');
				    		decks[key].complete = true;
				    		$('#deck-no').prop('disabled',false);
							$('#state-rooms').removeClass('disable-stateroom');
				    		$('#ship-overlay').hide();
				    		
				    	}
				    }, 0 );
				deckPlans.hasOfficerCabinsOnly(deck) ? $('#btnPublicAreas').trigger('click') : $('#btnStaterooms').trigger('click');
			}
			else{
				$('#deck-no').prop('disabled',false);
				$('#state-rooms').removeClass('disable-stateroom');
				deckProgressBar.addClass('invisible');
				$('#ship-overlay').hide();
				$('#btnPublicAreas').trigger('click');
			}
			// add accessibility features
			if ( $svg.length ) {
				$svg.attr('role', 'img');
				$svg.attr('tabindex', '0');
				$svg.prepend( $title );
				$svg.find('desc').attr('id','svg-desc-' + clean_deck_no ).text( svg_description );
				$svg.attr('aria-labelledby','svg-title-' + clean_deck_no + ' ' + 'svg-desc-' + clean_deck_no );
				$svg[0].setAttribute('class','svg-deck-diagram');
				$svg[0].setAttribute('focusable','true');
			}
		});
	},
	
	hasOfficerCabinsOnly : function( deck ){
		var officerCabinOnly = false;
		for( var room in deck.cabins) {
			officerCabinOnly  =  ( deck.cabins[room].category.code === 'Y' );
		}
		return officerCabinOnly;
	},
	
	draw : function(i, deck, paper){
		var room = i;
		var cabin;
		var cabinText;
		var cabinHitArea;
	    if( deck.cabins[room] != null && deck.cabins[room].path != null ){

			var roomNo = deck.cabins[room].number;
	    	
			cabin = paper.path(deck.cabins[room].path).attr(deckStyle.cabinDefault);
			cabinText = paper.text(0,0,roomNo).attr(deckStyle.cabinDefaultText);

			
			 switch (deck.cabins[room].textMatrix){
		     	case '0 1 -1 0':
		     		cabinText.transform('M'+deck.cabins[room].textMatrix+','+(deck.cabins[room].textX+5)+','+(deck.cabins[room].textY+22));
		        	break;
		        case '1 0 0 1':
		        	cabinText.transform('M'+deck.cabins[room].textMatrix+','+(deck.cabins[room].textX+20)+','+(deck.cabins[room].textY-5));
		        	break;
		        case '0 -1 1 0':
		        	cabinText.transform('M'+deck.cabins[room].textMatrix+','+(deck.cabins[room].textX-5)+','+(deck.cabins[room].textY-19));
		        	break;
			 }
		    
			
			 cabinHitArea = paper.path(deck.cabins[room].path).attr(deckStyle.hitArea);
			 cabinHitArea.node.id = 'cabin-' + roomNo ;
			 
			 var data = {
				'number': roomNo,
				'noOfBerths' : deck.cabins[room].numberOfBerths,
				'categoryCode': deck.cabins[room].category.code,
				'metaCode': deck.cabins[room].category.meta.code,
				 'subMetaCode': deck.cabins[room].subMetaCode,
				'metaName': deck.cabins[room].category.meta.name,
				'wheelchairAccessible': deck.cabins[room].wheelchairAccessible,
                'accessible': deck.cabins[room].accessible,
				'color':'#'+deck.cabins[room].cmsCategoryColor,
				'desc': deck.cabins[room].cmsCategoryShortDescription,
				'categoryName': deck.cabins[room].cmsCategoryName,
				'shipCode': deck.cabins[room].shipCode,
				'connectingRoom': deck.cabins[room].connectingRoom,
				'version': deck.cabins[room].shipVersion,
				'familySuite' : deck.cabins[room].familySuite
			};
			 
			 
			cabinHitArea.data(data);
			cabin.data(data);
			cabinText.attr(deckStyle.cabinText);

			var g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
			var a = document.createElementNS('http://www.w3.org/2000/svg', 'a');
			g.setAttribute('id','group-' + roomNo );
			g.setAttribute('role','listitem');
			a.setAttribute('id','link-' + roomNo );
			a.setAttribute('xlink:href','#link-' + roomNo) ;
			a.setAttribute('tabindex','0');
			a.setAttribute('focusable','true');
			a.setAttribute('class','svg-group-link');
			a.setAttribute('data-room-no', roomNo);
			$(a).focusSVGElement();
			var $group = $(cabin.node).add(cabinText.node).add(cabinHitArea.node);
			$group.wrapAll(g);
			$group.wrapAll(a);
			 
			 var currentCabin;
			 var currentCabinText;
			 
			 //cabin hover effects
			 cabinHitArea.hover(function(){
				 currentCabin = this.prev.prev;
				 currentCabinText = this.prev;
				 if(cabinFound){
					 if( filter.result( cabinFound )){
						 cabinFound.animate({
				 				fill: cabinFound.data('color')
				 			}, 0);
					 }
					 else{
						 cabinFound.animate({
						 		fill: deckStyle.cabinDefault.fill
						 	}, 0);
					 }
					cabinFoundText.animate({
						 fill: deckStyle.cabinText.fill
					 }, 0);
			 	 }	
				
				 currentCabin.animate({
					 fill: deckStyle.hover.fill
				 }, 0);
				 currentCabinText.animate({
					 fill: deckStyle.hoverText.fill
				 }, 0);

			 	},
			 	function(){
			 		if( filter.result( this )){
			 			currentCabin.animate({
			 				fill: this.data('color')
			 			}, 0);
			 		}
			 		else{
					 	currentCabin.animate({
					 		fill: deckStyle.cabinDefault.fill
					 	}, 0);
			 		}
					currentCabinText.animate({
					 	fill: deckStyle.cabinText.fill
					}, 0);
				 	 
			 }) 
			 allCabins[roomNo] = {
					 hitArea: cabinHitArea,
					 node: cabinHitArea.node,
					 cabin : cabin,
					 number : roomNo,
					 deckNumber : deck.cabins[room].deckNumber,
                     accessible : deck.cabins[room].accessible
			 };

			 return cabinHitArea;
	    }
	},
	
	colorFill : function(deck){
		var numFilled = 0, firstColoredCabin, found = false, c, availableMetas=[];
		$('#deck-'+deck).find('[id*="cabin"]').each(function(){
			var curCabin = allCabins[deckPlans.getCabinNo($(this).attr('id'))];
			var c = curCabin.cabin;
			var hA = curCabin.hitArea;
			var $link = $(c.node.parentNode);
			
			if( filter.result(c) ){
				if(!found){
					firstColoredCabin =$(allCabins[deckPlans.getCabinNo($(this).attr('id'))].node);
					found = true;
				}
				c.attr({fill: c.data('color')});
				
				hA.prev.attr({
					fill: deckStyle.cabinText.fill
				});
				if($.inArray(c.data('metaCode'), availableMetas) === -1) {					
					availableMetas.push(c.data('metaCode'));
				}
				// allow tab focus if this cabin is in the filter set
				$link.attr('tabindex','0');
				numFilled++;
			}
			else{
				c.attr({fill: '#fff'});
				hA.prev.attr({
					fill: deckStyle.cabinText.fill
				});
				// no tab focus if this cabin is not in the filter set
				$link.attr('tabindex','-1');
			}
		});		
		if( numFilled == 0 /*&& c != null*/){
			$('#wheelchair-accessible').prop('checked',false);
			$('#connection-cabins').prop('checked',false);
			$('#number-passengers').val('2');			
			filter.wheelchair = false;
			filter.connectingCabin = false;
			filter.noOfPax = 2;
			this.mfpLightbox( 'inline', '#filter-no-staterooms', 'No matching staterooms', 640 );
		}else if(filter.metas.length <= 0){
			$('#meta-category tr[id^="meta-"]').each(function(){				
				if($.inArray($(this).find('input[type=checkbox]').val(), availableMetas) >= 0) {
					$(this).removeClass('hidden')
				}else{
					$(this).addClass('hidden')
				}
			});	
		}
		
		/* Shelfing
		if( found && !firstColoredCabin.isOnScreen()){
			$('html, body').animate({ scrollTop: firstColoredCabin.offset().top - 375}, 1000);
		}
		*/
		return (numFilled > 0);
	},

	attachCabinClickHandlers: function () {

		$('.svg-group-link').on('click touchstart keyup',function (e) {

			// capture enter key only
			if ( e.type === 'keyup' && e.keyCode !== 13 ) return;
			
			var $this = $(this),
				room = $this.attr('data-room-no'),
				cabin = allCabins[room].hitArea;
				
			deckPlans.hideQtips();
			deckPlans.clickOpenCabin( cabin, e );

		});
	},

	mfpOptions: function ( mfpType, mfpSrc, mfpTitle, maxWidth ) {
		return {

			items: {
				src: mfpSrc
			},
			closeMarkup: '<div class="mfp-close-wrapper"><div class="mfp-close-inner-wrapper"><button title="%title%" class="mfp-close"><i class="mfp-close-icn">Close</i></button></div></div>',
			type: mfpType,
			removalDelay: 300,
			alignTop: true,
			mainClass: 'border-box-sizing',
			overflowY: 'scroll',
			callbacks: {
				open: function() {
					var item = this.currItem,
						container = this.container;
					
					lightboxOpenFocusFix(item, container);

					if ( maxWidth ) {

						container.find('.mfp-content').css('max-width', maxWidth);
						container.find('.mfp-close-wrapper').css({
							'max-width': maxWidth,
							'margin':'0 auto'
						});
					}

				},
				elementParse: function(item) {
					
					if (item.type == 'inline') {
						//if the inline content is within a script tag, we need to grab the content for the lightbox
						if ( $(item.src).is('script') ) {
							item.src = $(item.src).html();
						}
						
						//Wrap results in default template
						item.src = deckPlans.mfpTpl($(item.src).clone());
						
						//Populate title
						if ( mfpTitle ) {
							$(item.src).find('#popupTitleArea > .title').html( mfpTitle );
						}
					}
				},				
				markupParse: function(template, values, item) {
					var self = $.magnificPopup.instance.st.callbacks;
					//Populate iframe height
					if (typeof item.el.data('mfp-iframe-height') != 'undefined' && item.el.data('mfp-iframe-height') != '') {
						$(template).find('iframe').css('height', item.el.data('mfp-iframe-height'));
					}
					//Populate iframe width
					if (typeof item.el.data('mfp-iframe-width') != 'undefined' && item.el.data('mfp-iframe-width') != '') {
						$(template).find('iframe').css('width', item.el.data('mfp-iframe-width'));
					}
					// callback to affect the iframe contents after its loaded
					$(template).find('iframe').on("load", function () {
						self.iframeLoaded( this );
					})
				},
				// for Deck Plan > Gallery, we use an iframe, and the background is black which doesn't match the lightbox. Make it white.
				iframeLoaded: function (iframe) {
					
					if ( !iframe ) return;

					$(iframe).contents().find('body').addClass('white-bg');

				},
                parseAjax: function(mfpResponse) {
                    var currItem = this.currItem.el;

                    var is_error = true;
                    
                    // for failed HTML responses, we'll get the global_error page which has scripts which will run when appended to the page. To avoid this, check inside the response to see if it has the class 'results-error', which indicates error page, and deliver an error message instead of the response.
                    is_error = !!$(mfpResponse.data).find('.results-error').length;

                    if ( is_error ) {

                      mfpResponse.data = deckPlans.mfpTpl($("<p class='red'>Sorry, We are unable to retrieve this content.</p>"));
                      $(mfpResponse.data).find('#popupTitleArea > .title').html(mfpTitle);

                    } else {
                    
                      mfpResponse.data = deckPlans.mfpTpl(mfpResponse.data);
                      
                      //Populate title
                      if ( mfpTitle ) {
                          $(mfpResponse.data).find('#popupTitleArea > .title').html(mfpTitle);
                      }

                      //Apply popupContainer class if the results don't include the container
                      if (!$(mfpResponse.data).is('#popupContainer')) {
                          mfpResponse.data = $(mfpResponse.data).addClass('popupContainer');
                      }                
                    }
                },
                close: function() {
                	$('#container').removeAttr('aria-hidden');
                }				
			}
		}
	},

	mfpLightbox: function ( mfpType, mfpSrc, mfpTitle, maxWidth ) {

		var options = this.mfpOptions( mfpType, mfpSrc, mfpTitle, maxWidth ),
			lightbox = $.magnificPopup;

        // if MFP is already open we need to reset the instance's type (not necessary when using the open-mfp class, but necessary when we call open() directly)
        if ( $.magnificPopup.instance.isOpen ) {

        	lightbox = $.magnificPopup.instance;
        	lightbox.st.type = options.type;

        }

		lightbox.open( options );

	},

	mfpTpl: function(content,tplId) {
		//default template
		var $tpl = $('<div />',{'id':'popupContainer', 'class':'container'}).html('<div id="popupTitleArea"> <span class="ir seawitch"></span> <h2 class="title"></h2> </div> <div id="popupContent" class="col-xs-12"></div>');
		
		//grab custom template is provided
		if (typeof tplId != 'undefined') {
			$tpl = $(tplId).html();
		}
		
		var $markup = $tpl;
		
		//convert string into jquery object
		if (typeof $markup == 'string') {
			var parseHTML = $.parseHTML($markup);
			$markup = $(parseHTML[1]);
		}
		
		//insert content into template
		if ($(content).hasClass('hidden')) {
			content = $(content).removeClass('hidden');
		}
		if ($(content).hasClass('mfp-hide')) {
			content = $(content).removeClass('mfp-hide');
		}
		
		$markup.find('#popupContent').html(content);
		
		return $markup;
	},	
		
	attachQtip : function(){
		// var cabins = $('#deck-'+filter.deck).find('[id*="cabin"]');
		var cabins = $('#deck-'+filter.deck).find('.svg-group-link');
		
		$('<div />').qtip({
			content: ' ',
			position: {
				my: 'bottom center',
				at: 'center center',
				target: 'event',
				effect: false,
				adjust: {
					x: adjustTipX()
				}
			},
			show: {
				solo: true,
				effect: false,
				target: cabins,
				event: 'mouseenter focusin'
			}, 
			hide: {
				fixed: true,
				delay: 200,
				target: cabins,
				event: 'mouseleave focusout'
			},
			style: {
				tip: {
					height: 25,
					width: 12,
					border: 1
				},
				width: 370
			},
			events: {
				show: function(event, api){
					// Update the content of the tooltip on each show
					var $tooltip = $(api.elements.tooltip),
						$trigger_el = $(event.originalEvent.currentTarget),
						cabin_path = $trigger_el.find('[id*="cabin"]'),
						cabin, title;
					
					if ( cabin_path.length ) {
						cabin = allCabins[deckPlans.getCabinNo(cabin_path.attr('id'))].hitArea;
						$trigger_el.attr('aria-describedby',$tooltip.attr('id'));
						api.set('content.text', deckPlans.getCabinText(cabin));		
						api.set('style.classes',' ui-tooltip-princess');
						title = cabin.data('categoryName') + '<span class="regular"> &ndash; ' + cabin.data('number') + '</span>';
						api.set('content.title.text', title);
					}
				},
			
				render: function(e,api){

					var $tooltip = $(api.elements.tooltip);
					$tooltip.attr('role','tooltip');

				}
			}
				 
		});
	},
	
	hideQtips : function(){
		var qtips = $('.qtip');
		if( qtips.length > 0 ){
			qtips.qtip('api').hide();
		}
	},
	
	removeQtips : function(){
		var qtips = $('.qtip');
		if( qtips.length > 0 ){
			qtips.qtip('api').destroy();
		}
	},
	
	clickOpenCabin : function(cabin, e){
		e.preventDefault();
		var url = '/getCabinDetails.do?shipCode='+cabin.data('shipCode')+'&version='+cabin.data('version')+'&number='+cabin.data('number')+'&shipName='+ship.name;
		deckPlans.mfpLightbox( 'ajax', url, 'Stateroom Details' );
	},
	getCabinText : function(cabin){
		var cabinToolTip = $('#c-tooltip').clone();
		var url = '';
	 	if(cabin.data('wheelchairAccessible')){
	 		cabinToolTip.find('.ada-stateroom').removeClass('hidden');
            var accessibleType = cabin.data('accessible'); 
            var accessibleDesc = "";
            if(accessibleType === "A"){
                accessibleDesc = "Ambulatory Accessible Cabins (AAC)" 
                cabinToolTip.find('.ada-stateroom').addClass('hidden');
            }
            if(accessibleType === "W"){
                accessibleDesc = "Fully Accessible Cabins (FAC)"
            }
            if(accessibleType === "M"){
                accessibleDesc = "Fully Accessible Cabins – Single Side Approach (FAC-SSA)"
            }
            cabinToolTip.find('.ada-stateroom').after("<p>"+accessibleDesc+"</p>");
	 	}
	 	var number = cabin.data('number');
	 	var version = cabin.data('version');
	 	var shipCode = cabin.data('shipCode');
		var subMetaId = cabin.data('metaCode') + cabin.data('subMetaCode');
		var categoryCode = cabin.data('categoryCode');
		cabinToolTip.find('.desc').text(cabin.data('desc'));
		// SubMetaCategoryImgMapping defines edge cases wherein the category code must be used for image rendering instead of subMetaId. Extracts this out of the raw HTML from server.
		// First checks if it holds the selected ship. If it does, we check if the selected subMeta is contained there. In that case, use it's categoryCode instead.
		var mappingEl = document.getElementById('SubMetaCategoryImgMappingMap');
		var subMetaCategoryImgMapping = JSON.parse(mappingEl.innerText).data;
		var matchedSubMetaCategory = subMetaCategoryImgMapping[shipCode] && subMetaCategoryImgMapping[shipCode].find((el) => el.categoryCode === categoryCode);
		var catUrlString = matchedSubMetaCategory && `cat_${matchedSubMetaCategory.categoryCode}`;
		var imgUrl = `/static/images/global/book/ships/${shipCode}/submeta/${shipCode}_${(catUrlString || subMetaId)}_photo_sm.jpg`;
		cabinToolTip.find('.tooltip-stateroom-img').attr('src',imgUrl.toLowerCase());
	 	
	 	url = '/getCabinDetails.do?shipCode='+shipCode+'&version='+version+'&number='+number;
	 	
	 	var link = cabinToolTip.find('.details');
	 	link.text('Click to view details').attr('href',url);
	 	return cabinToolTip;
	},
	
	getPaper : function(deckNo){
		return Raphael('deck-'+deckNo, 410, 2500);
	},
	
	getCabinNo : function(id){
		return id.substring('cabin-'.length,id.length );
	}
};

function adjustTipX(){
	if(typeof window.webkitConvertPointFromNodeToPage === 'function'){
		return -2;
	}
	return 22;
}

$.fn.isOnScreen = function(){
     
    var win = $(window);
     
    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();
     
    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();
     
    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
     
};

$(document).on('click','a.date-button', function(e) {	
	e.preventDefault();
	var target = $(this);
	
	if(target.attr('href') != '#'){
		window.location = target.attr('href');
		return false;
	}
	ship.code = target.data('ship');
	filter.deck = target.data('deck');
	var version = target.data('version');
	if( version != filter.version ){
		filter.version = version;
		//$('.qtip').remove();
	}
	
	var date = target.text();
	$('#change-date-text').text($.trim(date));
	loadDeckPlan();	
});

function loadDeckPlan(){
	$.ajax({
			type: 'POST',
			cache: false,
			data: {shipCode: ship.code, version: filter.version},
			url: 'deckPlans.do',
			dataType: 'html'
	}).done(function( data ){			
		$('#deck-holder').html(data);
		initDeckPlans();
		$('#deckplan').animate({
			opacity: 100
		});
		$('#deck-plan-landing').animate({
			opacity: 0
		});
	});
}
